import { createContext } from 'react';
import utils from 'utils';
import { AgreementField } from 'models/Agreement';
import { AgreementPageSize, AgreementPoint } from 'agreementCoordinatesUtils';
import { FieldTypeConfig } from '../../utils';

type FieldEditorContextProps = {
  fields: AgreementField[];
  selectedField?: AgreementField;
  placingConfig?: FieldTypeConfig;
  invalidFieldIds: string[];
  isDraggingField: boolean;
  setSelectedFieldId: (fieldId?: string) => void;
  setPlacingConfig: (config?: FieldTypeConfig) => void;
  setIsDraggingField: (isDragging: boolean) => void;
  addField: (
    page: number,
    center: AgreementPoint,
    pageSize: AgreementPageSize,
    config?: FieldTypeConfig,
  ) => void;
  updateField: (field: AgreementField) => void;
  removeField: (fieldId: string) => void;
};

export default createContext<FieldEditorContextProps>({
  fields: [],
  invalidFieldIds: [],
  isDraggingField: false,
  setSelectedFieldId: utils.noop,
  setPlacingConfig: utils.noop,
  setIsDraggingField: utils.noop,
  addField: utils.noop,
  updateField: utils.noop,
  removeField: utils.noop,
});
